import React from 'react';
import { ColorToken, COLOR_TOKENS } from './tokens';

export function ColoredIcon({
  icon: Icon,
  color,
}: {
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  color: ColorToken;
}) {
  return <Icon style={{ color: COLOR_TOKENS[color] }} />;
}

export function renderIcon(
  icon: React.ComponentType | React.ReactNode,
): React.ReactNode {
  return typeof icon === 'function' ? React.createElement(icon) : icon;
}
